import { ForwardedRef, forwardRef } from 'react';
import classNames from 'classnames';
import { FieldWrapper } from 'framework/field/components/FieldWrapper';
import { Icon } from 'framework/Icon';

import { EMPTY_FUNCTION } from '../../constants';

import { useFieldTheme } from './hooks/useFieldTheme';
import { FieldElement } from './elements';
import { FieldProps } from './types';

import cn from './Field.module.scss';

export const Field = forwardRef<HTMLDivElement, FieldProps>(
  (
    {
      label = '',
      height = '32px',
      width = '100%',
      information = '',
      padding = '0px',
      autosize = false,
      error = false,
      disabled = false,
      background,
      left_icon,
      right_icon,
      is_focused = false,
      transparent = false,
      onClick = EMPTY_FUNCTION,
      onMouseDown = EMPTY_FUNCTION,
      theme,
      children,
    },
    ref?: ForwardedRef<HTMLDivElement>
  ) => {
    const field_theme = useFieldTheme(theme?.field);
    const auto_width = autosize ? 'fit-content' : width;

    return (
      <FieldWrapper
        label={label}
        information={information}
        width={auto_width}
        padding={padding}
        theme={field_theme.general}
      >
        <FieldElement
          ref={ref}
          className={classNames('transition', cn.field, {
            [cn.left]: left_icon,
            [cn.right]: right_icon,
          })}
          onClick={(e) => {
            if (!disabled) onClick(e);
          }}
          onMouseDown={(e) => {
            if (!disabled) onMouseDown(e, 'left');
          }}
          theme={field_theme}
          is_focused={is_focused}
          data-error={error}
          data-disabled={disabled}
          data-transparent={transparent}
          style={{ height, background }}
        >
          <Icon
            icon={left_icon}
            onMouseDown={(e) => onMouseDown(e, 'left')}
            width={field_theme.general.icon_width}
            disabled={disabled}
            button
          />
          {children}
          <Icon
            icon={right_icon}
            onMouseDown={(e) => onMouseDown(e, 'right')}
            width={field_theme.general.icon_width}
            disabled={disabled}
            button
          />
        </FieldElement>
      </FieldWrapper>
    );
  }
);
